import React, { useState } from "react";
import GruposList from "./GruposList";
import LoadSimple from "../LoadSimple";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";

const TableGrupos = ({
  pageActual,
  startLimit,
  limitList,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  mode,
  setContRowSelected,
  poolRows,setPoolRows,
  handleShowPopup,
  dataAnalisis
}) => {


  const [allSelected, setAllSelected] = useState(false); 
  // console.log(poolRows)
  setContRowSelected(poolRows.length)
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }
    setPoolRows((prevRows) => {
      // Busca si el groupId ya existe en el array
      const exists = prevRows.includes(elemento.groupid);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(groupid => groupid !== elemento.groupid);
      } else {
        return [...prevRows, elemento.groupid];
      }
    });
  };
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
    } else {
      // Si no, selecciona todos los elementos
      // setPoolRows(dataList
      //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList)));
        // setPoolRows(dataList);
        setPoolRows(dataList.map(item => item.groupid))
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-small">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        <div className="field-head-table-mantenimiento field-larger">  Group ID</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'17%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])} </div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'17%'}}>{capitalizeFirstLetter(lang[languaje]['tipo'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['conectados'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['desconectados'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{capitalizeFirstLetter(lang[languaje]['desconocidos'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >{'Total'}</div>
        </div>
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <GruposList
            pageActual={pageActual}
            startLimit={startLimit}
             limitList={limitList} 
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            setContRowSelected={setContRowSelected}
            rowSelected={rowSelected}
            poolRows={poolRows}
            handleShowPopup={handleShowPopup}
            dataAnalisis={dataAnalisis}
          ></GruposList>
          
        )}
      </div>
    </div>
  );
};

export default TableGrupos;
